const testimonials = [
  { name: 'Sarah Mitchell', location: 'Worksop', rating: 5, text: 'Called when our fuse board tripped and left us with no power. The electrician arrived within 40 minutes, sorted the problem quickly, and was incredibly professional. Highly recommend!', job: 'Emergency Callout', initial: 'S' },
  { name: 'Dave & Karen Thompson', location: 'Retford', rating: 5, text: 'Fantastic job rewiring our 1960s house. Explained everything clearly beforehand, priced fairly, and the finish was immaculate. We\'ve used other electricians before but none came close to this standard.', job: 'Full House Rewire', initial: 'D' },
  { name: 'Michael Patel', location: 'Carlton in Lindrick', rating: 5, text: 'Needed an EICR certificate quickly for a property sale. Booked in for next day, report issued the same afternoon. Efficient, thorough, and clearly explained everything in the report.', job: 'EICR Certificate', initial: 'M' },
  { name: 'Janet Houghton', location: 'Worksop', rating: 5, text: 'Had my old fuse board upgraded as part of getting new home insurance. Really pleased — new consumer unit looks great, all labelled properly. Left the house spotless after the work.', job: 'Fuse Board Upgrade', initial: 'J' },
  { name: 'Rob Sinclair', location: 'Shireoaks', rating: 5, text: 'Added multiple new sockets and outdoor lighting to our garden. Excellent workmanship, cables hidden neatly, finished on time. Will definitely be using again for our loft conversion electrics.', job: 'Domestic Electrics', initial: 'R' },
  { name: 'Claire Watkinson', location: 'Worksop', rating: 5, text: 'As a landlord I need reliable tradespeople I can trust. This company has done EICR tests on 3 of my properties now — always professional, certificates issued promptly, and great communication throughout.', job: 'Landlord EICR x3', initial: 'C' },
];

export default function Testimonials() {
  return (
    <section className="py-20 bg-white font-body">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-gold-100 text-gold-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 border border-gold-200">
            Customer Reviews
          </span>
          <h2 className="font-heading font-extrabold text-navy-800 mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 2.8rem)' }}>
            Trusted by Worksop Homeowners
          </h2>
          <p className="text-navy-600/60 max-w-xl mx-auto leading-relaxed">
            Don&apos;t just take our word for it. Here&apos;s what our customers across Worksop, Retford, and the surrounding area say about us.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-cream rounded-xl p-6 border-l-4 border-gold-400 flex flex-col">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-gold-400 text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-navy-700/70 text-sm leading-relaxed mb-5 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-navy-800 rounded-full flex-shrink-0">
                  <span className="font-heading font-bold text-gold-400 text-lg">{t.initial}</span>
                </div>
                <div>
                  <p className="font-semibold text-navy-800 text-sm">{t.name}</p>
                  <p className="text-navy-600/50 text-xs">{t.location} · {t.job}</p>
                </div>
                <div className="ml-auto">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-google-fill text-navy-300/40 text-lg"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
